import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialPersonnelState: Dtos.Personnel & IRegistrationFormState = {
    id: null,
    salutationId: null,
    salutation: null,
    firstName: null,
    lastName: null,
    email: null,
    userName: null,
    emailSent: null,
    jobTitle: null,
    cvDate: null,
    membershipTypeId: null,
    membershipType: null,
    membershipExpiryDate: null,
    comments: null,
    professionalDisciplineId: null,
    professionalDiscipline: null,
    otherInterests: null,
    otherDisciplines: null,
    active: null,
    apiKey: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    autogeneratePassword: null,
    personnelRoleSummaries: [],
    openClinicaUserRoles: [],
    notes: [],
    display: null,
    displayWithSalutation: null,
    hasActiveDirectoryEntry: null,
    password: null,
    confirmPassword: null,
    personnelRoles: [],
    personnelInterests: [],
    personnelAddresses: [],
    personalAssistantId: null,
    personalAssistant: null,
    cvNoChangeConfirmedDate: null,
    cvRequestSentDate: null,
    pmbApprovalNCIInvestigatorNo: null,
    pmbApprovalDateOfNCIExpiry: null,
    medicalRegistrationExpiryDate: null,
    medicalIndemnityExpiryDate: null,
    sitePiApplicationDateApproved: null,
    personnelTraining: [],
    fellowships: [],
    saveAndReturn: null,
    electronicCV: null,
    trainingAndCertifications: null,
    sourceDocuments: [],
    outlookId: null,
    externalLinks: []
}

export interface IPersonnelReduxFormState {
    id: IFieldState<number>,
    salutationId: IFieldState<number>,
    firstName: IFieldState<string>,
    lastName: IFieldState<string>,
    userName: IFieldState<boolean>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>,
    personnelRoleSummaries: IFieldState<Dtos.PersonnelRoleSummary[]>,
    OpenClinicaUserRoles: IFieldState<Dtos.OpenClinicaUserRole[]>,
    notes: IFieldState<Dtos.NoteTypeNotes[]>,
    activeDirectoryUser: IFieldState<string>,
    hasActiveDirectoryEntry: IFieldState<boolean>,
    emailSent: IFieldState<boolean>,
    password: IFieldState<string>,
    confirmPassword: IFieldState<string>,
    apiKey: IFieldState<string>,
    personnelRoles: IFieldState<Dtos.PersonnelRole[]>,
    sourceDocuments: IFieldState<Dtos.SourceDocument[]>,
    personalAssistantId: IFieldState<number>,
    personalAssistant: IFieldState<Dtos.Personnel>,
    jobTitle: IFieldState<string>,
    residentialPostcode: IFieldState<string>,
    cvDate: IFieldState<string>,
    membershipTypeId: IFieldState<number>,
    membershipExpiryDate: IFieldState<string>,
    comments: IFieldState<string>,
    professionalDisciplineId: IFieldState<number>,
    personnelInterests: IFieldState<Dtos.PersonnelInterest[]>,
    autogeneratePassword: IFieldState<boolean>,
    displayWithSalutation: IFieldState<string>,
    otherInterests: IFieldState<string>,
    otherDisciplines: IFieldState<string>,
    personnelAddresses: IFieldState<Dtos.PersonnelAddress[]>,
    electronicCV: IFieldState<string>,
    sitePiApplicationDateApproved: IFieldState<string>
}
